import { cx } from "./utils";

export interface SkeletonProps {
  /** Shape. @default "text" */
  variant?: "text" | "rect" | "circle";
  /** CSS width. @default "100%" */
  width?: string | number;
  /** CSS height; defaults per variant. */
  height?: string | number;
  /** Repeat count for `text` lines. @default 1 */
  lines?: number;
  className?: string;
}

/** Loading placeholder block; announced as busy to assistive tech. */
export function Skeleton({
  variant = "text",
  width = "100%",
  height,
  lines = 1,
  className,
}: SkeletonProps) {
  const style = { width, ...(height != null ? { height } : {}) };
  if (variant === "text" && lines > 1) {
    return (
      <div className={cx("xz-skeleton-group", className)} aria-busy="true" aria-live="polite">
        {Array.from({ length: lines }, (_, i) => (
          <span
            key={i}
            className="xz-skeleton xz-skeleton--text"
            style={i === lines - 1 ? { width: "60%" } : style}
          />
        ))}
      </div>
    );
  }
  return (
    <span
      className={cx("xz-skeleton", `xz-skeleton--${variant}`, className)}
      style={style}
      aria-busy="true"
    />
  );
}
